import { Header } from "@/components/layout/Header";
import { SchoolHeadPeriodProvider } from "@/contexts/SchoolHeadPeriodContext";

export function SchoolHeadLayout({ children }: { children: React.ReactNode }) {
  return (
    <SchoolHeadPeriodProvider>
      <div className="min-h-screen bg-background">
        <Header />
        <main className="container px-4 py-6 mt-[147px]">{children}</main>
      </div>
    </SchoolHeadPeriodProvider>
  );
}
